import Action from "../interfaces/Action";
import ActionTypeEnum from "../enums/ActionTypeEnum";
import PaymentState from "../interfaces/payment/PaymentState";

const initialState: PaymentState = {
    gateways: [],
    tokenizedMethods: null,
    tokenizedMethodSelected: null,
    do_save: null,
    error: "",
};

export default function paymentReducer(state: PaymentState = initialState, action: Action) {
    switch (action.type) {
        case ActionTypeEnum.PAYMENT_GATEWAY_SET:
            return {
                ...state,
                gateways: action.gateways,
            };
        case ActionTypeEnum.PAYMENT_TOKENIZED_SET:
            return {
                ...state,
                tokenizedMethods: action.methods,
            };
        case ActionTypeEnum.PAYMENT_TOKENIZED_ADD: {
            const nextState = { ...state };
            nextState.tokenizedMethods = state.tokenizedMethods
                ? [...state.tokenizedMethods, action.method]
                : [action.method];
            return nextState;
        }
        case ActionTypeEnum.PAYMENT_TOKENIZED_REMOVE: {
            const nextState = { ...state };
            if (state.tokenizedMethods) {
                nextState.tokenizedMethods = state.tokenizedMethods.filter((method) => (action.method.nonce && action.method.nonce !== method.nonce)
                        || (action.method.method_token && action.method.method_token !== method.method_token));
            }
            return nextState;
        }
        case ActionTypeEnum.PAYMENT_TOKENIZED_SET_SELECTED:
            return {
                ...state,
                tokenizedMethodSelected: action.selected,
            };
        case ActionTypeEnum.PAYMENT_DEVICE_DATA_SET:
            return {
                ...state,
                device_data: action.deviceData,
            };
        case ActionTypeEnum.PAYMENT_DO_SAVE_SET:
            return {
                ...state,
                do_save: action.doSave,
            };
        case ActionTypeEnum.PAYMENT_ERROR_SET:
            return {
                ...state,
                error: action.error,
            };
        default:
            return state;
    }
}
